import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ce7087c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hlcontainer" }
const _hoisted_2 = { class: "hlcontainer__item item--info" }
const _hoisted_3 = { class: "hlcontainer__item item--form" }
const _hoisted_4 = { class: "hlcontainer__item item--links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_info_links_home = _resolveComponent("l-info-links-home")!
  const _component_l_links_form = _resolveComponent("l-links-form")!
  const _component_l_home_footer = _resolveComponent("l-home-footer")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_l_info_links_home)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_l_links_form)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_component_l_home_footer)
    ])
  ]))
}